"use strict";exports.__esModule = true;exports.default = void 0;var _default = {
  handleCloseButton(originalEvent) {
    this.emit('overlay-close', { originalEvent });
  } };exports.default = _default;module.exports = exports.default;